import styled from 'styled-components'

export const UngatedAssetDownloadContainer = styled.div`
  padding: 52px 48px 64px;
  background: ${p => p.theme.webMktPalette.background.white};
  box-shadow: 0px 16px 16px -8px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 541px;
  box-sizing: border-box;

  .GatedAsset__Title {
    font-weight: 600;
    font-size: 36px;
    line-height: 44px;
    letter-spacing: -2px;
    margin-top: 62px;
    margin-bottom: 16px;
    color: ${p => p.theme.webMktPalette.text.primaryBlack};
  }

  .GatedAsset__Body {
    margin-top: 0;
    margin-bottom: 32px;
  }

  img {
    position: absolute;
    right: 48px;
    top: 52px;
    width: 64px;
    height: 64px;
  }

  .CTA.GatedAsset__CTA {
    display: flex;
    justify-content: center;
  }

  ${p => p.theme.breakpoints.down('xs')} {
    padding-left: 0;
    padding-right: 0;
    max-width: unset;

    img {
      right: 0;
    }
  }
`
